import { Calendar as CalendarIcon, Clock, User, Video } from 'lucide-react'

const appointments = [
  { client: 'Maria Silva', lawyer: 'Dr. Ricardo', date: '08/10/2026', time: '09:00', type: 'Presencial', cause: 'Trabalhista', status: 'Confirmado' },
  { client: 'Ana Oliveira', lawyer: 'Dra. Patrícia', date: '08/10/2026', time: '14:30', type: 'Videochamada', cause: 'Contrato', status: 'Pendente' },
  { client: 'Fernanda Costa', lawyer: 'Dr. Ricardo', date: '09/10/2026', time: '10:00', type: 'Presencial', cause: 'Trabalhista', status: 'Confirmado' },
  { client: 'Roberto Alves', lawyer: 'Dra. Patrícia', date: '10/10/2026', time: '16:00', type: 'Videochamada', cause: 'Família', status: 'Confirmado' },
]

const statusStyles: Record<string, string> = {
  'Confirmado': 'bg-primary/10 text-primary',
  'Pendente': 'bg-accent/10 text-accent',
  'Cancelado': 'bg-destructive/10 text-destructive',
}

export default function AppointmentsPage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-serif text-2xl font-semibold text-foreground">Agendamentos</h1>
          <p className="mt-1 text-sm text-muted-foreground">Reuniões agendadas via WhatsApp</p>
        </div>
        <button className="flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors touch-target">
          Novo Agendamento
        </button>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {appointments.map((apt, i) => (
          <div key={i} className="rounded-lg border border-border bg-card p-5 space-y-4">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2 text-sm font-medium text-foreground">
                <CalendarIcon className="h-4 w-4 text-primary" />
                {apt.date}
              </div>
              <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusStyles[apt.status] || statusStyles['Pendente']}`}>
                {apt.status}
              </span>
            </div>

            <div>
              <p className="font-serif text-lg font-semibold text-foreground">{apt.client}</p>
              <p className="text-sm text-muted-foreground">{apt.cause}</p>
            </div>

            <div className="space-y-2 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4" />
                {apt.time}
              </div>
              <div className="flex items-center gap-2">
                <User className="h-4 w-4" />
                {apt.lawyer}
              </div>
              <div className="flex items-center gap-2">
                <Video className="h-4 w-4" />
                {apt.type}
              </div>
            </div>

            <div className="flex gap-2 pt-2 border-t border-border">
              <button className="flex-1 rounded-md border border-border py-2 text-xs font-medium text-foreground hover:bg-muted transition-colors touch-target">
                Editar
              </button>
              <button className="flex-1 rounded-md bg-primary py-2 text-xs font-medium text-primary-foreground hover:bg-primary/90 transition-colors touch-target">
                Detalhes
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}